import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import PeriodDropdown from './PeriodDropdown';
import Skeletons from '../Skeletons';

import Button from '../../../../components/Buttons/Button';
import ExportsViewContext from '../../../../components/AdvancedExportModal/ExportsViewContext';

import { subDays, format, ISODateFormat } from '../../../../utils/date';
import { generateDateTimeSuffix, isUnified } from '../../../../utils/helpers';

import { filtersSelector, generalSelector, generalSettingsSelector } from '../../selectors';
import { initParams } from '../../configs';

const { id, store, permissions } = initParams;

const buildPublisherEntity = (general) => ({
  ref_no: id,
  name: general.name,
  value: general.name,
  store,
  kind: isUnified(store) ? 'unified_publisher' : 'publisher',
  cross_store_publisher_id: id,
  itunes_connect_ref_no: general.ids_for_stores?.itunes_connect,
  google_play_ref_no: general.ids_for_stores?.google_play,
  parent_company_id: general.parent_company_id,
});

const PageHeader = () => {
  const general = useSelector(generalSelector);
  const filters = useSelector(filtersSelector);
  const { loaded } = useSelector(generalSettingsSelector);
  const { openAdvancedExportModal } = useContext(ExportsViewContext);

  if (!loaded || !general) return Skeletons.pageHeader;

  const reportParams = {
    entities: [buildPublisherEntity(general)],
    start_date: format(
      filters.period_from_date || subDays(filters.period_to_date, filters.period),
      ISODateFormat
    ),
    end_date: format(filters.period_to_date, ISODateFormat),
    name: `${general.name}_${generateDateTimeSuffix()}`,
  };

  return (
    <section className="publisher_page_header p-b">
      <div className="d-flex align-items-center">
        <div className="flex-grow">
          {isUnified(store) && (
            <div className="mb-lg">
              <h2 className="text-lg">{general.name}</h2>
              <ul className="entity-details-list">
                <li className="v-a-t">Publisher</li>
                <li className="v-a-t">
                  <i className="hicon-apple mr-xxxs" />
                  {general.itunes_total_apps_count || 0} apps
                </li>
                <li className="v-a-t">
                  <i className="hicon-play mr-xxxs" />
                  {general.google_total_apps_count || 0} apps
                </li>
              </ul>
            </div>
          )}
          <h2 className="text-md">
            Worldwide Totals (
            {general.total_apps_count ||
              (general.google_total_apps_count || 0) + (general.itunes_total_apps_count || 0)}{' '}
            apps)
          </h2>
        </div>
        <p className="text-quiet m-r-xs">Period:</p>
        <PeriodDropdown />
        {permissions.allowAdvancedExportModal && (
          <Button
            shape="square"
            variant="secondary"
            className="m-l-xs"
            onClick={(e) => openAdvancedExportModal(e, reportParams)}
          >
            <i className="hicon-download-thin" />
          </Button>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
